module.exports = __webpack_public_path__ + "img/icon-email.b805d602.svg";